import { BooleanField, TopToolbar, Datagrid, EditButton, List, RefreshButton } from 'react-admin';
import KillSwitch from './KillSwitch';
import ReloadScreens from './ReloadScreens';

const Actions = (props) => {
  return (
    <TopToolbar>
      <RefreshButton />
    </TopToolbar>
  );
};

const SettingList = (props) => {
  return (
    <List
      perPage={10}
      sort={{ field: 'createdAt', order: 'DESC' }}
      title="Carvana Collective - Settings / Utilities"
      actions={<Actions />}
    >
      <Datagrid bulkActionButtons={false}>
        <BooleanField source="active" label="Site Enabled" />
        <KillSwitch />
        <ReloadScreens />
        <EditButton />
      </Datagrid>
    </List>
  );
};

export default SettingList;
